import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import slugify from "react-slugify";
import { ApiLinkContext } from "../context/ApiLinkContext";
import { LanguageContext } from "../context/LanguageContext";
import ReactPaginate from "react-paginate";
import translations from "../data/langData";

const CvBank = () => {
  const { companyList } = useContext(ApiLinkContext);
  const [search,setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10; // Sayfa başına element sayı
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  const [sortOrder, setSortOrder] = useState('');
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
    window.scrollTo({ top: 500 });
  };

  const filteredData = companyList.filter((i)=>{
    if (search == "") {
      return i
    } else {
     return i.shirket_adi.toLowerCase().includes(search.toLowerCase()) || i.vezife.toLowerCase().includes(search.toLowerCase()) 
    }
  })

  const sortedData = [...filteredData];
  if (sortOrder === "asc") {
    sortedData.sort((a, b) => a.shirket_adi.localeCompare(b.shirket_adi)); // Sort by company name ascending
  } else if (sortOrder === "desc") {
    sortedData.sort((a, b) => b.shirket_adi.localeCompare(a.shirket_adi)); // Sort by company name descending
  }


  // Paginated data slice
  const currentData = sortedData.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );
  return (
    <div className="cvBank jobpostings" style={{ background: "#FAFAFA" }}>
      <div className="container-fluid">
        <div className="row g-3 p-4 py-3">
          <div className="cvBread  ">
            <h4 className="text-start">{t.karyeramerkezi1}</h4>
            <p>
              {t.homePage} {`>`} {t.isimkanlari} {`>`} {t.karyeramerkezi} {`>`} {t.karyeramerkezi1}
            </p>
            <h3 className="mt-4 ">{t.allcompany}</h3>
            <p>{companyList.length ? companyList.length : 0} {t.toplamsirket}</p>
          </div>
          <div className="col-6">
            <input
              type="text"
              placeholder={t.searchcompany}
              style={{ background: "#fff" }}
              onChange={(e)=>setSearch(e.target.value)}
            />
          </div>
          <div className="col-6">
            <div className="d-flex justify-content-end align-items-center">
              <select
                name=""
                id=""
                className=" w-50 p-3"
                style={{
                  border: "1px solid rgb(244, 244, 244)",
                  borderRadius: "10px",
                }}
                onChange={(e)=>setSortOrder(e.target.value)}
              >
                <option value="asc">{t.companyasc}</option>
                <option value="desc">{t.companydesc}</option>
              </select>
            </div>
          </div>
          <div className="allCvDetails">
            <div className="row ">
              {
                currentData.length == 0 && (
                  <p className="text-center my-5 fs-6">{t.notfoundcompany}</p>
                )
              }
              {currentData.map((item) => {
                return (
                  <div className="col-lg-6 col-md-6 col-sm-12 col-12  my-3">
                    <div className="row g-3">
                      <>
                        <NavLink
                          to={`/resume/${
                            slugify(
                            `${item.id}-${item.vezife}-${item.shirket_adi}`
                          ).toLowerCase()}`}

                          id="jobLink"
                        >
                          <div
                            className="col-lg-3 col-md-2 col-sm-12 col-12"
                            id="cvDetails"
                            style={{
                              borderTop: "2px solid #f3f3f3",
                              borderLeft: "2px solid #f3f3f3",
                              borderBottom: "2px solid #f3f3f3",
                              borderTopLeftRadius: "8px",
                              borderBottomLeftRadius: "8px",
                              background: "#fff",
                            }}
                          >
                            <div className=" d-flex justify-content-center align-items-center">
                              <img
                                src="https://www.shutterstock.com/image-vector/circle-line-simple-design-logo-600nw-2174926871.jpg"
                                alt=""
                                className="img-fluid"
                                style={{ objectFit: "contain" }}
                              />
                            </div>
                          </div>
                          <div
                            className="col-lg-9 col-md-10 col-sm-12 col-12"
                            id="cvDetails"
                            style={{
                              borderTop: "2px solid #f3f3f3",
                              borderRight: "2px solid #f3f3f3",
                              borderBottom: "2px solid #f3f3f3",
                              borderTopRightRadius: "8px",
                              borderBottomRightRadius: "8px",
                              background: "#fff",
                            }}
                          >
                            <div className="d-flex justify-content-between">
                              <div>
                                <h5 className="mt-3">
                                  {item.vezife}
                                  <br />
                                  <span
                                    style={{
                                      opacity: "0.5",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {item.shirket_adi}
                                  </span>
                                </h5>
                              </div>
                              <div className="d-flex">
                                <span className="heartIcon">
                                  <i class="fa-regular fa-heart"></i>
                                </span>
                              </div>
                            </div>
                            <br />
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                              <div className="d-flex align-items-center">
                                <i
                                  class="fa-solid fa-money-bill"
                                  style={{ color: "#4CAF50" }}
                                ></i>
                                <span className="ms-1">{item.maas_min} ₼ - {item.maas_max} ₼</span>
                                <div>
                                  <i
                                    class="fa-solid fa-location-dot ms-4"
                                    style={{ color: "#4CAF50" }}
                                  ></i>
                                  <span className="ms-1">{item.seher}</span>
                                </div>
                              </div>

                              <div>
                                <span>
                                  {t.date} {item.created_at.split(" ")[0]}
                                  
                                </span>
                              </div>
                            </div>
                          </div>
                        </NavLink>
                      </>
                    </div>
            
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div
                      className={`d-flex justify-content-center my-3 ${
                        currentData.length == 0 && "d-none"
                      }`}
                    >
                      <ReactPaginate
                        previousLabel={
                          <i className="fa-solid fa-chevron-left"></i>
                        }
                        nextLabel={
                          <i className="fa-solid fa-chevron-right"></i>
                        }
                        breakLabel={"..."}
                        pageCount={Math.ceil(
                          companyList.length / itemsPerPage
                        )}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={"react_pagination"}
                        activeClassName={"active"} // Aktiv səhifəyə "active" class-ı əlavə edilir
                        pageClassName={"page-item"} // Hər bir səhifə üçün class
                        previousClassName={"previous-page"} // Əvvəlki səhifə üçün class
                        nextClassName={"next-page"} // Növbəti səhifə üçün class
                        breakClassName={"break-page"} // "..." break üçün class
                        disabledClassName={"disabled"} // Aktiv olmayan səhifə üçün class
                      />
                    </div>
    </div>
  );
};

export default CvBank;
